// ContactModal.js
import React from 'react';
import Image from "../../../assets";

const styles = `
  .contact-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
  }
  .contact-modal {
    background: white;
    border-radius: 8px;
    width: 90%;              /* default: take most of screen on mobile */
    max-width: 400px;        /* never exceed this size on big screens */
    min-width: 280px;        /* prevent being too tiny */
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    position: relative;
  }
  .contact-modal-header {
    display: flex;
        justify-content: space-between;
        padding: 7px 10px;
        margin-bottom: 7px;
        border-bottom: 1px solid #F2F2F2;
        padding-top: 12px;
  }
  .contact-modal-title {
    font-size: 16px;
    font-weight: bold;
    color: #333;
  }
  .contact-modal-close {
    cursor: pointer;
    font-size: 20px;
    color: #666;
    border: none;
    background: none;
    position: relative;
    right: -5px;
  }
  .contact-option {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 0;
    text-decoration: none;
    color: #333;
    font-size: 14px;
    padding: 11px 14px;
  }
  .contact-option:hover {
    background: #f5f5f5;
  }
  .contact-option-icon {
    width: 20px;
    height: 20px;
    margin-right: 8px;
  }
  .contact-option-arrow {
    color: #999;
  }
`;

function ContactModal({ isVisible, onClose }) {
    if (!isVisible) return null;

    return (
        <>
            <style>{styles}</style>
            <div className="contact-modal-overlay" onClick={onClose}>
                <div className="contact-modal" onClick={(e) => e.stopPropagation()}>
                    <div className="contact-modal-header">
                      <div>&nbsp;</div>
                        <span className="contact-modal-title">Contact us via</span>
                        <button className="contact-modal-close" onClick={onClose}><img width="20" height="20" src={Image.xIcon} /></button>
                    </div>
                    <a href="https://wa.me/6568878777" target='blank' className="contact-option">
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <svg className="contact-option-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#25D366" viewBox="0 0 16 16">
                                <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
                            </svg>
                            WhatsApp us at +65 6887 8777
                        </div>
                        <span className="contact-option-arrow"><img width="10" height="10" src={Image.goIcon} /></span>
                    </a>
                    <a href="tel:+6568878777" className="contact-option">
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8.5px' }}>
                            {/* <svg className="contact-option-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#000" viewBox="0 0 16 16">
                <path d="M11 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM5 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"/>
                <path d="M8 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2"/>
              </svg> */}
                            <img width="20" height="20" src={Image.phoneIcon} />
                            Call us +65 6887 8777
                        </div>
                        <span className="contact-option-arrow"><img width="10" height="10" src={Image.goIcon} /></span>
                    </a>
                    {console.log("process.env.REACT_APP_LIVECHAT_LINK}",process.env.REACT_APP_LIVECHAT_LINK)}
                    <a href={`${process.env.REACT_APP_LIVECHAT_LINK}`} target='blank' className="contact-option" style={{marginBottom:'0.3rem'}}>  {/* Replace # with actual chat link or onClick */}
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8.5px' }}>
                            {/* <svg className="contact-option-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#000" viewBox="0 0 24 24">
                <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"/>
              </svg> */}
                            <img width="20" height="20" src={Image.chatIcon} />
                            Chat with us
                        </div>
                        <span className="contact-option-arrow"><img width="10" height="10" src={Image.goIcon} /></span>
                    </a>
                </div>
            </div>
        </>
    );
}

export default ContactModal;